import { Directive, forwardRef } from '@angular/core';
import { NG_VALIDATORS, AbstractControl, ValidatorFn, Validator, FormControl } from '@angular/forms';

import { Step1Data } from './Step1-DataModel';

// validation function
function validateDateFactory(): ValidatorFn {
	return (c: AbstractControl) => {

		///debugger;

		let day = c.parent.controls['selectedDay'] && c.parent.controls['selectedDay'].value;
		let month = c.parent.controls['selectedMonth'] && c.parent.controls['selectedMonth'].value;
		let year = c.parent.controls['selectedYear'] && c.parent.controls['selectedYear'].value;

		//let isValid = c.value > 0;
		let isValid = Step1Data.isValidDate(year, month, day);

		if (isValid) {
			return null;
		} else {
			return {
				dateOK: {
					valid: false
				}
			};
		}

	}
}


@Directive({
	selector: '[dateOK]',
	providers: [
		{ provide: NG_VALIDATORS, useExisting: DateValidator, multi: true }
	]
})
export class DateValidator implements Validator {
	validator: ValidatorFn;

	constructor() {
		///debugger;
		this.validator = validateDateFactory();
	}

	validate(c: FormControl) {
		///debugger;
		return this.validator(c);
	}

}


// WEBPACK FOOTER //
// ./src/app/step1-calc/date.validator.ts